export default __webpack_public_path__ + "static/media/672.96209341.png";